import * as axios from 'axios';


class ApiClient {
	
	private _apiRoot : string = '';

	constructor(apiRoot:string){
		this._apiRoot = apiRoot;
	}

	// The api reports a refused request as { message, error }, which alerts as
	// [object Object] unless the message is pulled out of it first.
	private describe(error: any) {
		var data = error && error.response && error.response.data;
		if (data && data.message) return data.message;
		if (typeof data === 'string' && data) return data;
		return String(error);
	}

	public request(resource:string) {
		console.time('Request:' + resource);

		var promise = axios.default.get(this._apiRoot + resource);
		return promise.then(response => {
			return response.data;
		}).catch(error => {
			alert(this.describe(error));
		});

		//return promise;
	}

	public post(resource: string, data: any, throwOnError = false) {

		console.time('Post:' + resource);
		var promise = axios.default.post(this._apiRoot + resource, data);

		return promise.then(response => {
			return response.data;
		}).catch(error => {
			alert(this.describe(error));
			if (throwOnError) throw error;
		});
	}

	public put(resource: string, data: any, throwOnError = false) {

		console.time('Put:' + resource);
		var promise = axios.default.put(this._apiRoot + resource, data);

		return promise.then(response => {
			return response.data;
		}).catch(error => {
			console.log(error);
			alert(this.describe(error));
			if (throwOnError) throw error;
		});

		//return promise;
	}

	public delete(resource: string) {

		console.time('Delete:' + resource);
		return axios.default.delete(this._apiRoot + resource).then(response => {
			return response.data;
		}).catch(error=>{
			console.log(error);
			alert(this.describe(error));
		})		
	}
}

export default new ApiClient('/api/');
